import {
  FETCH_AUTOPROCINTEGRATION_JOB_TYPES,
  FETCH_DATACOLLECTIONGROUP_JOB_TYPES,
  FETCH_DATACOLLECTIONS_JOB_TYPES,
  FETCH_DATACOLLECTION_JOB_TYPES,
  FETCH_JOBS,
} from '../constants/ActionTypes'
import { getJobTypes, getJobsByUsername } from '../api/is4a.js'

import ISPyB from '../config/config.js'
import { axios } from 'config/axios'

export function loadJobs(username) {
  return function (dispatch) {
    dispatch({ type: FETCH_JOBS, payload: ISPyB.sites[0] })
    dispatch({ type: FETCH_DATACOLLECTION_JOB_TYPES, payload: axios.get(getJobTypes('mx', 'datacollection')) })
    dispatch({ type: FETCH_DATACOLLECTIONS_JOB_TYPES, payload: axios.get(getJobTypes('mx', 'datacollections')) })
    dispatch({
      type: FETCH_DATACOLLECTIONGROUP_JOB_TYPES,
      payload: axios.get(getJobTypes('mx', 'datacollectiongroup')),
    })
    dispatch({
      type: FETCH_AUTOPROCINTEGRATION_JOB_TYPES,
      payload: axios.get(getJobTypes('mx', 'autoprocintegration')),
    })
    dispatch({ type: FETCH_JOBS, payload: axios.get(getJobsByUsername(username)) })
  }
}
